import Vue from 'vue'
import Vuex from 'vuex'
import ui from './ui'
import fullpage from './fullpage'
import fpcard from './fpcard'
import footer from './footer'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    ui,
    fullpage,
    fpcard,
    footer
  }
})
